import { render, staticRenderFns } from "./PaymentTypeSelector.vue?vue&type=template&id=6b829f32&scoped=true&lang=pug&"
import script from "./PaymentTypeSelector.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTypeSelector.vue?vue&type=style&index=0&id=6b829f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b829f32",
  null
  
)

component.options.__file = "PaymentTypeSelector.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {
  VBtn,
})
